import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CityServicesService } from 'src/app/shared/services/city-services/city-services.service';
import { CustomerService } from 'src/app/shared/services/customer-services/customer.service';
import { IndustryTypeService } from 'src/app/shared/services/industry-type-services/industry-type.service';
import { StateServicesService } from 'src/app/shared/services/state-services/state-services.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-customer-profile-personal-details',
  templateUrl: './customer-profile-personal-details.component.html',
})
export class CustomerProfilePersonalDetailsComponent
  implements OnInit, OnDestroy
{
  pagination: any = {
      limit: 10000,
      currentPage: 1,
  };
  personalDetails = true;
  customerPersonalForm!: FormGroup;
  customerDataObsSubscription!: Subscription;
  customerDataEventObsSubscription!: Subscription;
  stateList: any;
  cityList: any;
  selectedCity: any;
  selectedState: any;
  industryTypeList: any;
  selectedIndustry: any;
  responseData: any;
  singleRole: any;
  loginRole: any;

  constructor(
    private formBuilder: FormBuilder,
    private customerService: CustomerService,
    private stateService: StateServicesService,
    private cityService: CityServicesService,
    private userService: UserService,
    private industryService: IndustryTypeService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loginRole = this.userService.getUserRole();
    // this.getCityList(this.pagination);
    this.getStateList(this.pagination);
    this.getIndustryTypeList(this.pagination)
    this.customerDataObsSubscription = this.customerService
      .getCustomerDataObservable()
      .subscribe((res) => {
        console.log("r",res);
        this.singleRole=res?.role?.type
        this.responseData = res;
        this.patchCustomerPersonalData(res);
      });

    this.customerDataEventObsSubscription = this.customerService
      .getCustomerFormDataEventObsevable()
      .subscribe((res) => {
        console.log(res);
        let formData = this.customerPersonalForm.value;
        let payload: any = {};
        payload.alternatePhone = formData.alternatePhone ? formData.alternatePhone : this.responseData.alternatePhone;
        payload.name =  formData.name;
        payload.email = formData.email;
        payload.city = this.selectedCity ? this.selectedCity : this.responseData.city;
        payload.state =  this.selectedState ? this.selectedState : this.responseData.state;
        // resellerId: data.resellerId,
        payload.address = formData.address;
        payload.industryCategory =  this.selectedIndustry ? this.selectedIndustry : this.responseData.industryType;
        payload.businessName =  formData.businessName;
        payload.phone = formData.phone;
        payload.pincode =  formData.pincode;
        this.customerService.sendCustomerFormData(
          payload
        );
      });
  }

  initForm() {
    this.customerPersonalForm = this.formBuilder.group({
      name: [''],
      phone: ['', [
        Validators.maxLength(10),
        Validators.pattern(/^[6-9]\d{9}$/),]],
      businessName: [''],
      alternatePhone: [''],
      address: [''],
      state: [''],
      email: ['', [ Validators.email]],
      // resellerId: ['', Validators.required],
      city: [''],
      industryType: [''],
      pincode: ['', [ Validators.pattern('[0-9]{6}')]],
    });
  }

  getCityList(pagination: any) {
    this.cityService.getCityWithPagination(pagination).subscribe({
      next: (res) => {
        console.log(res)
       this.cityList = res.data.data;
      },
      error: (err) => {
        console.log(err);
       
      },
      complete: () => console.log('Observable complete'),
    })
  }
  

  getStateList(pagination: any) {
    this.stateService.getStateWithPagination(pagination).subscribe({
      next: (res) => {
        console.log(res)
       this.stateList = res.data.data;
      },
      error: (err) => {
        console.log(err);
       
      },
      complete: () => console.log('Observable complete'),
    })
    // this.selectedState = this.stateData.find(
    //   (item: any) => item._id == ev.target.value
    // );
    // this.cityService
    //   .getCityWithPagination(pagination, this.selectedState._id)
    //   .subscribe((res: any) => {
    //     this.cityData = res.data.data;
    //   });
  }

  getIndustryTypeList(pagination: any) {
    this.industryService.getIndustryTypes(pagination).subscribe({
      next: (res) => {
        console.log(res)
       this.industryTypeList = res.data.data;
      },
      error: (err) => {
        console.log(err);
       
      },
      complete: () => console.log('Observable complete'),
    })
  }

  patchCustomerPersonalData(data: any) {
    console.log("customer",data);
   
    this.customerPersonalForm.patchValue({
      // PayId: data.PayId,
      alternatePhone: data.alternatePhone,
      name: data.name,
      email:data.email,
      state: data?.state?.stateId ? data?.state?.stateId : '',
      // resellerId: data.resellerId,
      address: data.address,
      industryType: data?.industryType?.industryTypeId ? data?.industryType?.industryTypeId : '',
      businessName: data.businessName,
      phone: data.phone,
      pincode: data.pincode
    });
    let pagination = {
      currentPage: 1,
      limit:10000
    }
    if(data?.state?.stateId){
      this.cityService
      .getCityWithPagination(pagination,data?.state?.stateId)
      .subscribe((res: any) => {
        this.cityList = res.data.data;
        setTimeout(() => {
          this.customerPersonalForm.patchValue({
            city: data?.city?.cityId ? data?.city?.cityId : '',
          })
        },1000)
      
        console.log(this.cityList)
        console.log(this.customerPersonalForm)
      });
    }
   
    // this.customerPersonalForm.get('businessName')?.disable();
    // this.customerPersonalForm.get('businessName')?.updateValueAndValidity();
  }

  onCitySelect(ev: any) {
    this.selectedCity = this.cityList.find(
      (item: any) => item._id == ev.target.value
    );
    console.log(this.selectedCity)
  }

  onIndustrySelect(ev: any) {
    this.selectedIndustry = this.cityList.find(
      (item: any) => item.industryTypeId == ev.target.value
    );
  }

  onStateSelect(ev: any) {
    let pagination = {
      currentPage: 1,
      limit: 10000,
    };
    this.selectedState = this.stateList.find(
      (item: any) => item._id == ev.target.value
    );
    this.cityService.getCityWithPagination(pagination, this.selectedState._id).subscribe((res: any) => {
      this.cityList = res.data.data;
    });
  }

  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }


  ngOnDestroy(): void {
    this.customerDataObsSubscription?.unsubscribe();
    this.customerDataEventObsSubscription?.unsubscribe();
  }
}
